// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Import server Config
import apiLink from '@configs/serverConfig'

// ** Axios Imports
import axios from 'axios'

// ** Rent
export const getServiceCarsList = createAsyncThunk('appServiceCar/getServiceCarsList', async params => {
    params.page = params.page === 0 ? 0 : params.page - 1    
    const response = await axios.post(apiLink('getServiceCars'), params)    
    
    return {
        params,
        data: response.data.content,
        totalPages: response.data.totalElements
    }
})
export const addServiceCar = createAsyncThunk('appServiceCar/addStation', async (data) => {
    const response = await axios.post(apiLink('addServiceCar'), data)
    return response.data
})
export const updateServiceCar = createAsyncThunk('appServiceCar/updateServiceCar', async (data) => {
    const response = await axios.put(apiLink({name: 'updateServiceCar', value: data.id}), data)
    return response.data
})
export const getServiceCar = createAsyncThunk('appServiceCar/getServiceCar', async (id) => {
    const response = await axios.get(apiLink({name: 'getServiceCar', value: id}))
    return response.data
})
export const removeServiceCar = createAsyncThunk('appServiceCar/removeServiceCar', async (id) => {
    const response = await axios.delete(apiLink({name: 'removeServiceCar', value: id}))
    return response.data
})

// Company cars
export const getCompanyCars = createAsyncThunk('appServiceCar/getCompanyCars', async () => {
    const response = await axios.get(apiLink('getCarsShortList', {sort_list: 'id', sort_order: 'ASC', page: 0, rows: 1000}))
    return response.data.cars
 })

export const appServiceCarSlice = createSlice({
    name: 'appServiceCar',
    initialState: {
        cars: [],    
        total: 1,
        params: {},
        settings: [],
        selectedCar: null
    },
    reducers: {},
    extraReducers: builder => {
        builder
        .addCase(getServiceCarsList.fulfilled, (state, action) => {
            state.cars = action.payload.data
            state.params = action.payload.params
            state.total = action.payload.totalPages
        })            
    }
})

export default appServiceCarSlice.reducer